<!--
 * @Author: caogt
-->
<template>
  <div class="template-container">
    <div class="main-box1">
      <div class="main">
        <div class="yx-name">{{ $t('fzxt.text1') }}</div>
        <div class="yx-text">
          {{ $t('fzxt.text2') }}
        </div>
      </div>
    </div>
    <div class="main-box2">
      <div class="box2-name" style="position: absolute;top: 45px;width: 438px">
        {{ $t('fzxt.text3') }}
        <div class="box2-txt">{{ $t('fzxt.text4') }}</div>
      </div>
      <div class="box2-name" style="position: absolute;bottom: 94px;width: 300px">
        {{ $t('fzxt.text5') }}
        <div class="box2-txt">
          {{ $t('fzxt.text6') }}
        </div>
      </div>
      <div class="main box2-content">
        <div class="content">
          <img class="box2-img1" src="/static/images/v2/fzxt/fz_img1.png">
          <div class="box2-name">
            <span style="color: #fff">{{ $t('fzxt.text7') }}</span>
            2.0
            <div class="box2-txt">{{ $t('fzxt.text8') }}<br>
              {{ $t('fzxt.text9') }}
            </div>
          </div>
          <img class="box2-img2" src="/static/images/v2/fzxt/fz_img2.png">
        </div>
        <div class="line"></div>
        <div class="content">
          <img class="box2-img3" src="/static/images/v2/fzxt/fz_img3.png">
          <div class="box2-name">
            <span style="color: #fff">{{ $t('fzxt.text10') }}</span>
            3.0
            <div class="box2-txt">{{ $t('fzxt.text11') }}</div>
          </div>
          <img class="box2-img4" src="/static/images/v2/fzxt/fz_img4.png">
        </div>
      </div>
    </div>
    <div class="main-box3">
      <div class="main">
        <div class="box3-top">
          <div class="title">{{ $t('fzxt.text12') }}</div>
          <div class="text">
            {{ $t('fzxt.text13') }}
          </div>
        </div>
        <div class="body-img">
          <div class="left">
            <div class="title">{{ $t('fzxt.text14') }}</div>
            <div class="text">
              {{ $t('fzxt.text15') }}
            </div>
          </div>
          <img class="left" src="/static/images/v2/fzxt/fz_list1.png">
        </div>
      </div>
    </div>
    <div class="main-box4">
      <img class="box4-item" src="/static/images/v2/fzxt/fz_bg_l.png">
      <div class="box4-item">
        <img src="/static/images/v2/fzxt/fz_bg_c.png" style="width: 100%">
        <div style="position: absolute;bottom: 0">
          <div class="title">{{ $t('fzxt.text16') }}</div>
          <div class="text">
            {{ $t('fzxt.text17') }}
          </div>
        </div>
      </div>
      <img class="box4-item" src="/static/images/v2/fzxt/fz_bg_r.png">
    </div>
    <div class="main-box5">
      <div class="main">
        <div class="body-img" v-for="(item,index) in $t('fzxt.list')" :key="index" :style="{flexDirection: index % 2 === 0 ? 'row' :'row-reverse'}">
          <div class="left">
            <div class="title">{{item.name}}</div>
            <div class="text">
              {{item.text}}
            </div>
          </div>
          <img class="left" :src="item.url">
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
// import { isMobileDevice } from '@/common/scripts/isMobile.js';

export default {
  data() {
    return {

    };
  },
  created() {

  },
  mounted() {

  },
  methods: {},
};
</script>

<style lang="stylus" scoped>
.template-container {
  position: relative;
  width: 100%;
  background: #242424;
  color: #fff;

  .main {
    width: 1280px;
  }

  .body-img {
    display: flex;

    .left {
      height: 430px;
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-bottom: 30px;
    }

    .title {
      margin-bottom: 15px;
      color: #1F65FE;
      font-size: 24px;
      font-weight: 600;
    }

    .text {
      width: 331px;
      font-size: 14px;
      font-weight: 600;
      line-height: 22px;
      color: #FFFFFF;
    }
  }

  .main-box1 {
    width: 100%;
    height: calc(100vh - 60px);
    display: flex;
    align-items: flex-end;
    justify-content: center;
    background-size: cover;
    background-position: center;
    background-image: url("/static/images/v2/fzxt/fz_bg1.png");

    .yx-name {
      font-size: 64px;
      font-weight: 800;
      padding-bottom: 60px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    }

    .yx-text {
      margin: 40px 0;
      font-size: 16px;
      font-weight: 600;
      line-height: 22px;
    }
  }

  .main-box2 {
    text-align: center;
    width: 100%;
    display: flex;
    position: relative;
    justify-content: center;
    background: linear-gradient(180deg, #1F1F1F 0%, #2A2A2A 100%);

    .box2-name {
      font-size: 24px;
      font-weight: 600;
      color: #1F65FE;
    }

    .box2-txt {
      margin-top: 15px;
      color: #fff;
      font-size: 14px;
      font-weight: 600;
      line-height: 22px;
    }

    .box2-content {
      margin-top: 95px;
      display: flex;

      .content {
        flex: 1;
      }

      .line {
        margin-top: 100px;
        width: 1px;
        height: 718px;
        background: #D8D8D8;
        opacity: 0.2;
      }

      .box2-img1 {
        margin-left: 50px;
        object-fit: contain;
        height: 336px;
      }

      .box2-img2 {
        object-fit: cover;
        width: 544px;
        height: 578px;
        margin-bottom: 50px;
      }

      .box2-img3 {
        object-fit: contain;
        height: 336px;
      }

      .box2-img4 {
        margin-top: 132px;
        margin-left: 180px;
        object-fit: cover;
        width: 430px;
        height: 334px;
      }
    }
  }

  .main-box3 {
    width: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    background-size: cover;
    background-position: top;
    background-image: url("/static/images/v2/fzxt/fz_bg3.png");

    .box3-top {
      margin-left: 839px;
      margin-bottom: 203px;

      .title {
        margin-top: 186px;
        margin-bottom: 15px;
        font-size: 24px;
        font-weight: 800;
        color: #FFFFFF;
      }

      .text {
        width: 300px;
        font-size: 14px;
        font-weight: 600;
        line-height: 22px;
      }
    }
  }

  .main-box4 {
    width: 100%;
    display: flex;

    .box4-item {
      width: 33.333%;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;

      .title {
        margin-bottom: 15px;
        font-size: 24px;
        font-weight: 800;
        color: #FFFFFF;
      }

      .text {
        text-align: center;
        width: 400px;
        font-size: 14px;
        font-weight: 600;
        line-height: 22px;
        margin-bottom: 15px;
      }
    }
  }
  .main-box5{
    margin-top: 30px;
    padding-bottom: 120px;
    flex-direction: column;
    align-items: center;
    width: 100%;
    display: flex;
  }
}

@media all and (max-width: 768px) {
  .template-container {
    width: 100%;
    display: flex;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/industry/fzxt/index.vue